<template>
  <div>
    <b-tabs
        pills
        fill
    >
      <b-tab active>
        <template #title>
          <feather-icon icon="InfoIcon" />
          <span>Genel</span>
        </template>
    <b-card>
      <b-row>
        <b-col
          cols="12"
        >
          <title-text />
        </b-col>
        <b-col cols="12">
          <summary-text />
        </b-col>
        <b-col cols="12">
          <content-text />
        </b-col>
      </b-row>
    </b-card>
    <b-row>
      <b-col cols="12" md="6">
        <image-card />
      </b-col>
      <b-col cols="12" md="6">
        <photo-gallery />
      </b-col>
    </b-row>
        <b-card>
          <video-embed />
        </b-card>
    <photo-gallery />
      </b-tab>
      <b-tab>
        <template #title>
          <feather-icon icon="InfoIcon" />
          <span>Üretim İçerikleri</span>
        </template>
        <items-card />
      </b-tab>
    </b-tabs>
    <b-button
      variant="primary"
      :disabled="itemData.submitStatus"
      @click="submitForm"
    >
      Kaydet
    </b-button>
  </div>
</template>

<script>
import {
  BCard, BCol, BRow, BButton, BTab, BTabs,
} from 'bootstrap-vue'

import TitleText from '@/views/Admin/Production/elements/Title.vue'
import SummaryText from '@/views/Admin/Production/elements/Summary.vue'
import ContentText from '@/views/Admin/Production/elements/Content.vue'
import ImageCard from '@/views/Admin/Production/elements/Image.vue'
// import ImageCard2 from '@/views/Admin/Production/elements/Image2.vue'
import PhotoGallery from '@/views/Admin/Production/elements/PhotoGallery.vue'
import ItemsCard from "@/views/Admin/Production/elements/itemsCard.vue";
import VideoEmbed from "@/views/Admin/Collections/elements/VideoEmbed.vue";

export default {
  name: 'ItemForm',
  components: {
    VideoEmbed,
    ItemsCard,
    BTabs, BTab,
    BCard,
    BRow,
    BCol,
    BButton,
    TitleText,
    SummaryText,
    ContentText,
    ImageCard,
    // ImageCard2,
    PhotoGallery,
  },
  props: {
    submitForm: {
      type: Function,
      required: true,
    },
  },
  computed: {
    itemData() {
      return this.$store.getters['production/dataItem']
    },
  },
}
</script>
